export enum LocationPermissionEnum {
  'DENIED'= 0,
  'PROMPT' = 10,
  'GRANTED'= 20
}